<template>
  <div class="table screen_table--2">
    <div class="table__top">
      <div class="table__top_left">
        CHARACTERISTICS
      </div>
      <div class="table__top_right">
        ASCLEPIOS II (N=955)
      </div>
    </div>
    <ScrollTable
        :swipe-icon="true"
        class=""
        :delay-before-init="100"
        :fixed-side-class="'table__td--fixed'"
        :resolution="resolution"
        :table-min-width="tableMinWidth"
    >
      <table class="table__bottom" ref="table">
      <thead class="table__thead">
        <th class="table__th table__th--first table__td--fixed">
          <div class="table__colon_bg" :style="{'height': height + 'px'}"></div>
        </th>
        <th class="table__th table__th--second">
          <div class="table__colon_bg" :style="{'height': height + 'px'}"></div>
          <div class="table__th_content">
            Teriflunomide (n=474)
          </div>
          <div class="table__th_decor"></div>
        </th>
        <th class="table__th table__th--third">
          <div class="table__colon_bg" :style="{'height': height + 'px'}"></div>
          <div class="table__th_content">
            KESIMPTA (n=481)
          </div>
          <div class="table__th_decor"></div>
        </th>
      </thead>
      <tbody class="table__tbody">
        <tr class="table__tr">
          <td class="table__td table__td--subtitle table__td--fixed">
            DEMOGRAPHICS
          </td>
          <td class="table__td"></td>
          <td class="table__td"></td>
        </tr>
        <tr class="table__tr">
          <td class="table__td table__td--first table__td--fixed">
            Age (years)
          </td>
          <td class="table__td table__td--second">
            38.2±9.5
          </td>
          <td class="table__td table__td--third">
            38.0±9.3
          </td>
        </tr>
        <tr class="table__tr">
          <td class="table__td table__td--first table__td--fixed">
            Female (%)
          </td>
          <td class="table__td table__td--second">
            67.3
          </td>
          <td class="table__td table__td--third">
            66.3
          </td>
        </tr>
        <tr class="table__tr">
          <td class="table__td table__td--subtitle table__td--fixed">
            TYPE OF MS
          </td>
          <td class="table__td"></td>
          <td class="table__td"></td>
        </tr>
        <tr class="table__tr">
          <td class="table__td table__td--first table__td--fixed">
            Relapsing-remitting (%)
          </td>
          <td class="table__td table__td--second">
            94.9
          </td>
          <td class="table__td table__td--third">
            94.0
          </td>
        </tr>
        <tr class="table__tr">
          <td class="table__td table__td--first table__td--fixed">
            Secondary progressive (%)
          </td>
          <td class="table__td table__td--second">
            5.1
          </td>
          <td class="table__td table__td--third">
            6.0
          </td>
        </tr>
        <tr class="table__tr">
          <td class="table__td table__td--subtitle table__td--fixed">
            DISEASE HISTORY
          </td>
          <td class="table__td"></td>
          <td class="table__td"></td>
        </tr>
        <tr class="table__tr">
          <td class="table__td table__td--first table__td--fixed">
            Time since symptom onset (years)
          </td>
          <td class="table__td table__td--second">
            8.19±7.38
          </td>
          <td class="table__td table__td--third">
            8.20±7.40
          </td>
        </tr>
        <tr class="table__tr">
          <td class="table__td table__td--first table__td--fixed">
            Time since diagnosis (years)
          </td>
          <td class="table__td table__td--second">
            5.48±6.00
          </td>
          <td class="table__td table__td--third">
            5.59±6.38
          </td>
        </tr>
        <tr class="table__tr">
          <td class="table__td table__td--first table__td--fixed">
            No previous DMTs (%)
          </td>
          <td class="table__td table__td--second">
            38.2
          </td>
          <td class="table__td table__td--third">
            40.5
          </td>
        </tr>
        <tr class="table__tr">
          <td class="table__td table__td--subtitle table__td--fixed">
            RELAPSES
          </td>
          <td class="table__td"></td>
          <td class="table__td"></td>
        </tr>
        <tr class="table__tr">
          <td class="table__td table__td--first table__td--fixed">
            Number of relapses in last <nobr>12 months</nobr>
          </td>
          <td class="table__td table__td--second">
            1.3±0.7
          </td>
          <td class="table__td table__td--third">
            1.3±0.7
          </td>
        </tr>
        <tr class="table__tr">
          <td class="table__td table__td--subtitle table__td--fixed">
            DISABILITY
          </td>
          <td class="table__td"></td>
          <td class="table__td"></td>
        </tr>
        <tr class="table__tr">
          <td class="table__td table__td--first table__td--fixed">
            EDSS score
          </td>
          <td class="table__td table__td--second">
            2.86±1.37
          </td>
          <td class="table__td table__td--third">
            2.90±1.34
          </td>
        </tr>
        <tr class="table__tr">
          <td class="table__td table__td--subtitle table__td--fixed">
            LESIONS
          </td>
          <td class="table__td"></td>
          <td class="table__td"></td>
        </tr>
        <tr class="table__tr">
          <td class="table__td table__td--first table__td--fixed">
            Volume of lesions on <nobr>T2-weighted</nobr> MRI (cm<sup>3</sup>)
          </td>
          <td class="table__td table__td--second">
            12.0
          </td>
          <td class="table__td table__td--third">
            14.3
          </td>
        </tr>
        <tr class="table__tr">
          <td class="table__td table__td--first table__td--fixed">
            Patients free of GdE T1 lesions (%)
          </td>
          <td class="table__td table__td--second">
            61.4
          </td>
          <td class="table__td table__td--third">
            56.1
          </td>
        </tr>
        <tr class="table__tr">
          <td class="table__td table__td--first table__td--fixed">
            Number of GdE lesions per <nobr>T1-weighted</nobr> MRI scan
          </td>
          <td class="table__td table__td--second">
            1.5
          </td>
          <td class="table__td table__td--third">
            1.6
          </td>
        </tr>
      </tbody>
    </table>
    </ScrollTable>
  </div>
</template>

<script>
// components
import ScrollTable from '../ScrollTable/ScrollTable';

// vuex
import { mapState } from 'vuex';

export default {
  name: "Table2",
  data() {
    return {
      height: 0
    }
  },
  components: {
    ScrollTable
  },
  computed: {
    ...mapState(['UserAgent']),
    resolution: function () {
      return (
          this.$route.query.screentest_graphs ? Infinity :
          this.UserAgent.window.width >= 1024 ? 1250 : 600
      )
    },
    tableMinWidth: function () {
      return this.UserAgent.window.width >= 1024 ? '500px' : '375px'
    }
  },
  methods: {
    resizeBg() {
      setTimeout(() => {
        if(this.$refs.table) {
          const borderSpace = 8;
          this.height = this.$refs.table.offsetHeight - borderSpace;
        }
      }, 150);
    },
  },
  watch: {
    'UserAgent.window.width'() {
      this.resizeBg();
    }
  },
  mounted() {
    this.resizeBg();
  }
}
</script>

<style scoped lang="scss">
$border-space: 8px;

.table {
  line-height: normal;
  position: relative;
  &__top {
    background-color: $table-bg-1;
    color: $table-bg-3;
    font-size: 18px;
    text-transform: uppercase;
    font-weight: 700;
    padding: 8px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
    border-radius: 4px;
    @media (max-width: $mobile) {
      font-size: 14px;
    }
  }
  &__top_left,
  &__top_right {
    width: 50%;
  }
  &__top_right {
    text-align: center;
  }
  &__bottom {
    border-collapse: separate;
    border-spacing: $border-space;
    margin: -$border-space;
  }
  &__thead {

  }
  &__th {
    font-size: 18px;
    font-weight: 700;
    color: $table-color-1;
    position: relative;
    @media (max-width: $mobile) {
      font-size: 16px;
    }
    &--second,
    &--third {
      text-align: center;
    }
    &--third {
      color: white;
    }
  }
  &__th_content {
    position: relative;
  }
  &__th_decor {
    position: absolute;
    top: auto;
    bottom: -$border-space;
    background-color: $table-color-1;
    height: 1px;
    width: calc(100% - #{$border-space * 2});
    left: $border-space;
    .table__th--third & {
      background-color: white;
    }
  }
  &__colon_bg {
    position: absolute;
    width: 100%;
    background-color: $table-bg-1;
    border-radius: 8px;
    top: -$border-space;
    .table__th--first & {
      background-color: white;
      border-radius: 0;
      .scroll_table--cloned & {
        min-height: 1000vh;
      }
    }
    .table__th--third & {
      background-image: linear-gradient(148deg, $table-bg-2 10%, $table-bg-3 89%);
    }
  }
  &__td {
    color: $table-color-1;
    font-size: 18px;
    position: relative;
    @media (max-width: $mobile) {
      font-size: 16px;
    }
    &--subtitle {
      font-size: 12px;
      font-weight: 700;
    }
    &--first {
      padding-left: 32px;
      overflow: hidden;
      @media (max-width: $mobile) {
        padding-left: 16px;
      }
      &:after {
        content: "........................................................................................................................................................................................................................................................................................................................................";
        width: 1px;
        display: inline-block;
        font-size: 50%;
      }
    }
    &--second,
    &--third {
      text-align: center;
    }
    &--third {
      color: white;
    }
  }
}
</style>
